function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-general"), React.createElement("g", {
  id: "icon-general-icon-general",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M58.0564753,10 L34.3376141,36.0090222 L25.4222497,57.5725451 L13.7419155,50.4508412 L7.23719635,79.9133079 L94.7414513,79.9133079 L87.8236113,52.9997191 L81.0628191,57.8092322 L66.3962556,39.0929849 L58.0564753,10 Z M38.6367012,38.7899004 L55.7084945,20.0713096 L61.8410955,41.4621993 L80.070246,64.7270572 L84.782454,61.3751617 L88.241374,74.8350806 L13.5098252,74.8350806 L17.1281139,58.4474282 L27.8151013,64.9637443 L38.6367012,38.7899004 Z M57.0171747,45.1927942 L57.2361133,56.928725 L46.2474083,67.4773145 L59.9020579,63.0888388 L70.8327402,70.6565769 L63.7416061,57.605197 L57.0171747,45.1927942 Z M0,89.9057999 L0,84.8283538 L100,84.8283538 L100,89.9057999 L0,89.9057999 Z",
  id: "icon-general-Fill-2",
  fill: "#000"
}))));